import "/themes/landmark/assets/sass/style.scss";
var $ = require("jquery");

require("jquery/package.json"); // jquery is a peer dependency.
const jqueryValidation = require('jquery-validation');

var animateCss = require("animate.css");

var lity = require("lity");

import "@lottiefiles/lottie-player";

// require('iconify').load('icons.svg', {
// 	output: process.stdout // or any stream.Writable
// });

// var iconify = require("iconify");

// import { URLSearchParams } from 'url';

// import { createStyleObject } from '@capsizecss/core';
// import { fromFile } from '@capsizecss/unpack';

// const styles = createStyleObject({
// 	capHeight: 50,
// 	lineGap: 70,
//   	fontMetrics: fromFile('Boston-Regular.woff2')
// });

// JCF
global.module = global.module || {}
var jcf = require("jcf");

// set options for Checkbox module
jcf.setOptions('Select', {
	"wrapNative": false,
	"flipDropToFit": false,
	"maxVisibleItems": 10
});
jcf.setOptions('Radio', {
	"wrapNative": true,
	"checkedClass": "checked",
	"labelActiveClass": "active"
});

// // Custom validate
// $.validator.addMethod("aFunction",
// 	function (value, element) {
// 		if (value == "none")
// 			return false;
// 		else
// 			return true;
// 	},
// 	"Please select a value");

// replace all form elements with modified default options
// jcf.replace('button');
jcf.replace('select');
// // jcf.replace('textarea');
jcf.replace('input[type="checkbox"]');
jcf.replace('input[type="file"]');
jcf.replace('input[type="number"]');
jcf.replace('input[type="radio"]');
jcf.replace('input[type="file"]');
jcf.replace('input[type="range"]');
jcf.replace('.jcf-scrollable');

const wysiwyg_aos_blocks = document.querySelectorAll(".wysiwyg_aos_blocks");
// Opens modal at contact
wysiwyg_aos_blocks.forEach(wysiwyg_aos_block => {
	wysiwyg_aos_block.setAttribute("data-aos", "fade-right");
});

// AOS
import AOS from 'aos';
import 'aos/dist/aos.css';

AOS.init({
	// Global settings:
	disable: 'mobile', // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
	// disable: function () {
	//     var maxWidth = 768;
	//     return window.innerWidth < maxWidth;
	// }
	startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
	initClassName: 'aos-init', // class applied after initialization
	animatedClassName: 'aos-animate', // class applied on animation
	useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
	disableMutationObserver: false, // disables automatic mutations' detections (advanced)
	debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
	throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

	// Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
	offset: 200, // offset (in px) from the original trigger point
	delay: 0, // values from 0 to 3000, with step 50ms
	duration: 500, // values from 0 to 3000, with step 50ms
	easing: 'ease-in-out', // default easing for AOS animations
	once: true, // whether animation should happen only once - while scrolling down
	mirror: false, // whether elements should animate out while scrolling past them
	anchorPlacement: 'center-bottom', // defines which position of the element regarding to window should trigger the animation
});

// Rotate shapes on scroll
window.onscroll = function () {
	scrollRotate();
};
function scrollRotate() {
	let shapes = document.querySelectorAll("main > .shapes svg");
	for (var i = 0; i < shapes.length; i++) {
		shapes[i].style.opacity = "1";
		shapes[i].style.transform = "rotate(" + window.pageYOffset / 25 + "deg)";
	}
}



// Header
// Enables movement of site header on vertical scrolling + checks position onload
// const body = document.querySelectorAll("body");
// const body = bodyAll[0];
const body = $('body');
const html = document.querySelectorAll("html");
var lastScrollTop = 0,
	delta = 20,
	hero = document.querySelector(".hero").offsetHeight,
	shape = document.querySelector(".primary-navigation > ul::before"),
	header = $('.site-header'),
	nav_children = document.querySelectorAll('.menu-item-has-children');

// Remove active class from dropdown to prevent bugs if still hovering the menu.
function removeDropdownActiveClass() {
	// Remove active class from dropdown to prevent bugs if still hovering the menu.
	nav_children.forEach((nav_child, i) => {
		nav_child.parentElement.classList.remove('active');
		nav_child.classList.remove('active');
	});
}

function header_check() {
	const scroll = $(window).scrollTop(),
		//   content = 200,
		  content = hero/2,
		  st = scroll;

	// if (Math.abs(lastScrollTop - st) <= delta)
	// 	return;

	if( scroll >= hero ) {
		body.addClass("active-nav");
		body.addClass("sticky-nav");
		header.css('pointer-events', 'all');
		// header.css('transition', '0ms all ease-out');
		// shape.css('transition', '0ms all ease-out');
	}

	if (st > lastScrollTop) {
		// downscroll code
		if (scroll >= hero) {
			body.addClass("active-nav");
			// header.css('transition', '000ms all ease-out');
			// let timer = setTimeout(function () {
			header.css('transition', '300ms all ease-in-out');
			// 	// shape.css('transition', '500ms all ease-out');
			// }, 250);
		} else if (scroll >= content) {
			body.addClass("sticky-nav");
			header.removeClass("top");
			header.css('transition', '0ms all ease-in-out');
			header.css('pointer-events', 'all');
			removeDropdownActiveClass();
		}
	} else {
		// upscroll code
		if (scroll <= delta) {
			header.removeClass("top");
			return;
		}
		if (scroll <= content) {
			body.removeClass("sticky-nav");
			header.addClass("top");
			header.css('transition', '0ms top ease-in-out, 0ms height, 0ms padding');
			header.css('pointer-events', 'all');
			// return;
		} else if (scroll <= hero) {
			body.removeClass("active-nav");
			header.css('transition', '300ms all ease-in-out');
			removeDropdownActiveClass();
			header.css('pointer-events', 'none');
			// nav_children.forEach((nav_child, i) => {
			// 	header.css('pointer-events', 'none');
			// });
		}
	}
	lastScrollTop = st;
}

document.addEventListener("DOMContentLoaded", function () {
	header_check();
});
document.addEventListener('scroll', (event) => {
	header_check();
});

nav_children.forEach((nav_child, i) => {
	nav_child.addEventListener('mouseover', (e) => {
		nav_child.parentElement.classList.add('active');
		nav_child.classList.add('active');
	});
	nav_child.addEventListener('mouseout', (e) => {
		nav_child.parentElement.classList.remove('active');
		nav_child.classList.remove('active');
	});
});



// $(nav_child).hover(function () {
// 	$(this).parent().addClass("active");
// }, function () {
// 	$(this).parent().removeClass("active");
// });

// const body = $('body');
// const html = document.querySelectorAll("html");
// var lastScrollTop = 0,
// 	delta = 20,
// 	site_header = document.querySelector(".site-header").offsetHeight,
// 	hero = document.querySelector(".hero").offsetHeight,
// 	// shape = document.querySelector('.primary - navigation > ul'), ':before').getPropertyValue('content'),
// 	header = $('.site-header');

// var nav = document.querySelector('#primary-menu');
// console.log(nav);
// var shape = getComputedStyle(nav, '::before').getPropertyValue('content');
// // var shape = getComputedStyle(nav[0], '::after').getPropertyValue('content');
// // console.log(getComputedStyle(document.querySelector('.primary-navigation > ul'), ':before').getPropertyValue('content'));


// function header_check() {
// 	var scroll = $(window).scrollTop(),
// 		// nav_shape = document.querySelector('').offsetHeight;
// 		// content = 200,
// 		content = hero * .8,
// 		st = scroll;

// 	// if (Math.abs(lastScrollTop - st) <= delta)
// 	// 	return;

// 	if (scroll >= hero) {
// 		body.addClass("active-nav");
// 		body.addClass("sticky-nav");
// 		header.css('transition', '0ms all ease-out');
// 		// shape.css('transition', '0ms all ease-out');
// 	}

// 	if (st > lastScrollTop) {
// 		// downscroll code
// 		if (scroll >= hero) {
// 			body.addClass("active-nav");
// 			let timer = setTimeout(function () {
// 				header.css('transition', '500ms all ease-out');
// 				// shape.css('transition', '500ms all ease-out');
// 			}, 250);
// 		} else if (scroll >= content) {
// 			body.addClass("sticky-nav");
// 			header.removeClass("top");
// 			// header.css('transition', '0ms all ease-out');
// 		}
// 	} else {
// 		// upscroll code
// 		if (scroll <= delta) {
// 			header.removeClass("top");
// 			return;
// 		}
// 		if (scroll <= content) {
// 			body.removeClass("sticky-nav");
// 			header.addClass("top");
// 			// header.css('transition', '0ms top ease-out, 0ms height, 0ms padding');
// 			// return;
// 		} else if (scroll <= hero) {
// 			body.removeClass("active-nav");
// 			header.css('transition', '500ms all ease-in');
// 		}
// 	}
// 	lastScrollTop = st;
// }


// Parrallax Hero
const 	hero_standard = document.querySelector(".hero.standard"),
		h1 = document.querySelector(".hero.standard .content h1"),
		h4 = document.querySelector(".hero.standard .content h4"),
		button = document.querySelector(".hero.standard .content .button"),
		svg = document.querySelectorAll(".hero.standard img");

window.addEventListener("scroll", function () {
	// Check whether this exists
	let scroll = this.scrollY;
	if (h1) {
		h1.style.transform = "translateY(" + scroll / 3.5 + "px)";
	}
	if (h4) {
		h4.style.transform = "translateY(" + scroll / 4 + "px)";
	}
	if (button) {
		button.style.transform = "translateY(" + scroll / 4.5 + "px)";
	}
	if (svg[0]) {
		svg[0].style.transform = "translate(-" + scroll / 6 + "px, 0";
	}
	if (svg[1]) {
		svg[1].style.transform = "translate(" + scroll / 6 + "px, 0)";
	}
});

// $("a:not(:hidden)").each(function (i) { $(this).attr('tabindex', i + 1); });
$('a:visible').each(function () {
	$(this).attr('tabindex', '0');
});

// Handle anchor links
$('a[href*="#"]')
	// Remove links that don't actually link to anything
	.not('[href="#"]')
	.not('[href="#0"]')
	.click(function (event) {
		// On-page links
		if (
			location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
			location.hostname == this.hostname
		) {
			// Figure out element to scroll to
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
			// Does a scroll target exist?
			if (target.length) {
				// Only prevent default if animation is actually gonna happen
				event.preventDefault();
				$('html, body').animate({
					// Offset to height of nav or approx
					scrollTop: target.offset().top - 150
				}, 1000, function () {
					// Callback after animation
					// Must change focus!
					var $target = $(target);
					$target.focus();
					if ($target.is(":focus")) { // Checking if the target was focused
						return false;
					} else {
						$target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
						$target.focus(); // Set focus again
					};
				});
			}
		}
	});

import Swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const swiper_slider_testimonials = ()=>{
	let swiper_slider = document.querySelectorAll('.swiper-slider-testimonials');
	swiper_slider.forEach((slider, i)=>{
		const swiper = new Swiper(slider, {
			loop: true,
			centeredSlides: false,
			spaceBetween: 200,
			pauseOnMouseEnter: true,
			autoplay: {
				delay: 7500,
				speed: 500,
			},
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},
			breakpoints: {
				0: {
					slidesPerView: 1,
				},
			}
		});
	});
};
window.addEventListener('DOMContentLoaded', swiper_slider_testimonials);

const swiper_slider_news = ()=>{
	let swiper_slider = document.querySelectorAll('.swiper-slider-news');
	swiper_slider.forEach((slider, i)=>{
		const swiper = new Swiper(slider, {
			loop: true,
			centeredSlides: false,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},
			pauseOnMouseEnter: true,
			autoplay: {
				delay: 2500,
				speed: 500,
			},
			spaceBetween: 200,
			breakpoints: {
				0: {
					slidesPerView: 1,
				},
			}
		});
	});
};
window.addEventListener('DOMContentLoaded', swiper_slider_news);

const swiper_slider_media = ()=>{
	let swiper_slider = document.querySelectorAll('.swiper-slider-media');
	swiper_slider.forEach((slider, i)=>{
		const swiper = new Swiper(slider, {
			direction: 'horizontal',
			autoHeight: true,
			loop: true,
			slidesPerView: 1,
			spaceBetween: 50,
			pauseOnMouseEnter: true,
			autoplay: {
				delay: 2500,
				speed: 1000,
			},
			// navigation: {
			// 	nextEl: '.swiper-button-next',
			// 	prevEl: '.swiper-button-prev',
			// },
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},
		});
	});
};
window.addEventListener('DOMContentLoaded', swiper_slider_media);

// const swiper_slider = ()=>{
// 	let swiper_slider = document.querySelectorAll('.swiper-slider-slider');
// 	swiper_slider.forEach((slider, i)=>{
// 		const swiper = new Swiper(slider, {
// 			loop: true,
// 			centeredSlides: false,
// 			touchStartPreventDefault: false,
// 			simulateTouch: true,
// 			pauseOnMouseEnter: true,
// 			autoplay: {
// 				delay: 5000,
// 			},
// 			keyboard: {
// 				enabled: false,
// 				onlyInViewport: false,
// 			},
// 			navigation: {
// 				nextEl: '.swiper-button-next',
// 				prevEl: '.swiper-button-prev',
// 			},
// 			breakpoints: {
// 				0: {
// 					slidesPerView: 1,
// 				},
// 				768: {
// 					slidesPerView: 2,
// 				},
// 				1200: {
// 					slidesPerView: 4,
// 				},
// 			}
// 		});
// 	});
// };
// window.addEventListener('DOMContentLoaded', swiper_slider);

const swiper_slider_accreditations_header = ()=>{
	let swiper_slider = document.querySelectorAll('.swiper-slider-accreditations-header');
	swiper_slider.forEach((slider, i)=>{
		const swiper = new Swiper(slider, {
			loop: true,
			spaceBetween: 50,
			autoplay: {
				delay: 2500,
				disableOnInteraction: false,
			},
			breakpoints: {
				0: {
					slidesPerView: 2,
				},
				480: {
					slidesPerView: 3,
				},
				767: {
					slidesPerView: 5,
				},
			}
		});
	});
};
window.addEventListener('DOMContentLoaded', swiper_slider_accreditations_header);

const swiper_slider_accreditations_footer = ()=>{
	let swiper_slider = document.querySelectorAll('.swiper-slider-accreditations-footer');
	swiper_slider.forEach((slider, i)=>{
		const swiper = new Swiper(slider, {
			loop: true,
			spaceBetween: 50,
			autoplay: {
				delay: 2500,
			},
			breakpoints: {
				0: {
					slidesPerView: 2,
				},
				480: {
					slidesPerView: 3,
				},
				767: {
					slidesPerView: 5,
				},
			}
		});
	});
};
window.addEventListener('DOMContentLoaded', swiper_slider_accreditations_footer);

// Custom forms
const menu_toggle = document.querySelector(".menu-toggle");
const modalbody = document.querySelector("body");
// const menu_toggle = $('.menu-toggle');
const contact_buttons = document.querySelectorAll(".contact");
const quote_buttons = document.querySelectorAll(".quote");
const modal_contact = document.querySelector(".modal");
const modals = document.querySelectorAll(".modal");
const modal_form = document.querySelector(".form");
const modal_form_l = document.querySelector(".form .form__l");
const modal_form_r = document.querySelector(".form .form__r");

// Enable Terminix redirect modals
const modal_redirect = document.querySelector('.modal-redirect');
const modal_redirect_pestpulse = document.querySelector('.modal-redirect-pestpulse');
const modal_redirect_expert = document.querySelector('.modal-redirect-expert');
if (window.location.search.indexOf('?origin=terminix') > -1) {
	setTimeout(function () {
		html[0].classList.add("lock-scroll");
		modal_redirect.classList.toggle("active");
	}, 1000);
} else if (window.location.search.indexOf('?origin=pestpulse') > -1) {
	setTimeout(function () {
		html[0].classList.add("lock-scroll");
		modal_redirect_pestpulse.classList.toggle("active");
	}, 1000);
} else if (window.location.search.indexOf('?origin=expertpest') > -1) {
	setTimeout(function () {
		html[0].classList.add("lock-scroll");
		modal_redirect_expert.classList.toggle("active");
	}, 1000);
} else {
	// Nothing
}

const modal_location_quote = document.querySelector('#modal-location-quote');
const mmodal_location_contact = document.querySelector('#modal-location-contact');
const url = window.location.href;
if(modal_location_quote) {
	modal_location_quote.value = url;
}
if(mmodal_location_contact) {
	mmodal_location_contact.value = url;
}

// Open and close main navigation menus + icons
menu_toggle.addEventListener('click', (e) => {
	e.preventDefault();
	modalbody.classList.toggle("toggled");
	menu_toggle.classList.toggle("toggled");
	html[0].classList.toggle("lock-scroll");
});

// Opens modal at contact
contact_buttons.forEach(contact_button => {
	contact_button.addEventListener('click', (e)=> {
		console.log('contact');
		e.preventDefault();
		html[0].classList.add("lock-scroll");
		modal_contact.classList.toggle("active");
		modalbody.classList.add("modal-slide");
		modal_form.style.transition = "0ms all ease-in-out";
		modal_form_l.style.transition = "0ms all ease-in-out";
		modal_form_r.style.transition = "0ms all ease-in-out";
	});
});

// Opens modal at quote
const quote_button = document.querySelectorAll("#quote-button");
quote_buttons.forEach(quote_button => {
	quote_button.addEventListener('click', (e)=> {
		console.log('quote');
		e.preventDefault();
		html[0].classList.toggle("lock-scroll");
		modal_contact.classList.toggle("active");
		modal_contact.classList.remove("toggle");
		modal_form.style.transition = "0ms all ease-in-out";
		modal_form_l.style.transition = "0ms all ease-in-out";
		modal_form_r.style.transition = "0ms all ease-in-out";
	});
});

// // Opens modal at quote
// const primary_menu = document.querySelector("#primary-menu");

// primary_menu.addEventListener('mouseover', (e)=> {
// 	primary_menu.classList.add('active');
// });

// primary_menu.addEventListener('mouseout', (e)=> {
// 	primary_menu.classList.remove('active');
// });


// Slides modal content
const modal_buttons = document.querySelectorAll(".modal_button");
const wpcf7_response_outputs = document.querySelectorAll(".wpcf7-response-output");
const error_messages = document.querySelectorAll(".error-message");
const error_messages_text = document.querySelectorAll(".error-message p");
modal_buttons.forEach(modal_button => {
	modal_button.addEventListener('click', (e)=> {
		e.preventDefault();
		// Hides the rror messages on form toggle
		error_messages.forEach(error_message => {
			error_message.innerHTML = '';
			error_message.style.display = "none";
		});
		// wpcf7_response_outputs.forEach(wpcf7_response_output => {
		// 	wpcf7_response_output.innerHTML = '';
		// 	wpcf7_response_output.style.display = "none";
		// });
		const quote = document.querySelectorAll("#quote");
		const quote_forms = document.querySelectorAll("#quote *");
		// modal_contact.classList.toggle("toggle");
		modalbody.classList.toggle("modal-slide");
		modal_form.style.transition = "300ms all ease-in-out";
		modal_form_l.style.transition = "300ms all ease-in-out";
		modal_form_r.style.transition = "300ms all ease-in-out";
	});
});

var close_buttons = document.querySelectorAll(".close"),
	close_modal_buttons = document.querySelectorAll(".close-button"),
	overlays = document.querySelectorAll(".modal .overlay");

	// html[0].classList.remove("lock-scroll");

overlays.forEach(overlay => {
	overlay.addEventListener('click', (e) => {
		// Hides the rror messages on form toggle
		error_messages.forEach(error_message => {
			error_message.innerHTML = '';
			error_message.style.display = "none";
		});
		// Remove parameters
		let removeParam = window.location.href.split('?')[0];
		window.history.replaceState({}, null, removeParam);
		modals.forEach(modal => {
			modal.classList.remove("active");
			html[0].classList.remove("lock-scroll");
		});

	});
});

close_buttons.forEach(close_button => {
	close_button.addEventListener('click', (e) => {
		e.preventDefault();
		// Remove parameters
		let removeParam = window.location.href.split('?')[0];
		window.history.replaceState({}, null, removeParam);
		modals.forEach(modal => {
			modal.classList.remove("active");
			html[0].classList.remove("lock-scroll");
		});
	});
});

close_modal_buttons.forEach(close_modal_button => {
	close_modal_button.addEventListener('click', (e) => {
		e.preventDefault();
		modals.forEach(modal => {
			// Remove parameters
			let removeParam = window.location.href.split('?')[0];
			window.history.replaceState({}, null, removeParam);
			modal.classList.remove("active");
			html[0].classList.remove("lock-scroll");
		});
	});
});

const dropdown_buttons = document.querySelectorAll('.arrow')
dropdown_buttons.forEach(dropdown_button => {
	dropdown_button.addEventListener('click', (e) => {
		e.preventDefault();
		if (dropdown_button.parentElement.parentElement.classList.contains('toggle')) {
			dropdown_button.parentElement.parentElement.classList.remove('toggle');
			dropdown_button.classList.remove('active');
		} else {
			dropdown_buttons.forEach(dropdown_button => {
				dropdown_button.parentElement.parentElement.classList.remove('toggle');
				dropdown_button.classList.remove('active');
			});
			dropdown_button.parentElement.parentElement.classList.add('toggle');
			dropdown_button.classList.add('active');
		}
	});
});

$('input:radio[name="modal_property_type"]').change(function () {
	const id = $('#other_1');
	if ($(this).val() == 'residential') {
		$(id).css('display', 'block');
	} else {
		$(id).css('display', 'none');
	}
});

// $('input:radio[name="modal_pest_type"]').change(function () {
// 	const id = $('#other_1');
// 	if ($(this).val() == 'test') {
// 		$(id).css('display', 'block');
// 	}
// });

// vars for all form elements
let modal_property_type = $('input[name="modal_property_type"]'),
	modal_pest_type = $('select[name="modal_pest_type"]'),
	modal_house_type = $('input[name="modal_house_type"]'),
	modal_bedroom_size = $('input[name="modal_bedroom_size"]'),
	modal_location = $('input[name="modal_location"]'),
	modal_file = $('input[name="modal_file"]'),
	modal_textarea = $('textarea[name="modal_textarea"]'),
	modal_business_name = $('input[name="modal_business_name"]'),
	modal_full_name = $('input[name="modal_full_name"]'),
	modal_email = $('input[name="modal_email"]'),
	modal_telephone = $('input[name="modal_telephone"]'),
	modal_checkbox = $('input[name="modal_checkbox"]'),

	// contact_name = $('#contact_name'),
	contact_name = $('input[name="contact_name"]'),
	contact_email = $('input[name="contact_email"]'),
	contact_enquiry = $('textarea[name="contact_enquiry"]'),
	contact_checkbox = $('input[name="contact_checkbox"]'),

	isvalid = 1,
	quoteUrl = "https://vergo.developandtest.uk/wp-content/themes/vergo/template-parts/forms/modal_quote.php",
	contactUrl = "https://vergo.developandtest.uk/wp-content/themes/vergo/template-parts/forms/modal_contact.php",
	current = 1;

// get radio values
// $('input[name="property_type"]').change(function () {
// 	property = $(this).val();
// 	console.log(property);
// });
// $('input[name="house_type"]').change(function () {
// 	property = $(this).val();
// 	console.log(property);
// });

const form = $('#quote'),
	progressNumber = document.querySelectorAll(".step").length,
	slidePage = document.querySelector(".slide-page"),
	pages = document.querySelectorAll(".page"),
	nextButtons = document.querySelectorAll(".next"),
	prevButtons = document.querySelectorAll(".prev"),
	stepsNumber = document.querySelectorAll(".page").length;

document.documentElement.style.setProperty("--stepNumber", stepsNumber);

for (let i = 0; i < nextButtons.length; i++) {
	nextButtons[i].addEventListener("click", function (event) {
		event.preventDefault();
		console.log(current);
		if (current == 1) {
			var validationPassed = modal_property_type.valid();
			if (validationPassed == false) {
				return false;
			}
			var validationPassed = modal_pest_type.valid();
			if (validationPassed == false) {
				return false;
			}
			var validationPassed = modal_house_type.valid();
			if (validationPassed == false) {
				return false;
			}
			// if (property_val == 'Other') {
			// 	validationPassed = property_other.valid();
			// 	if (validationPassed == false) {
			// 		return false;
			// 	}
			// }
		}
		if (current == 2) {
			var validationPassed = modal_location.valid();
			console.log(validationPassed);
			if (validationPassed == false) {
				return false;
			}
			var validationPassed = modal_file.valid();
			console.log(validationPassed);
			if (validationPassed == false) {
				return false;
			}
		}
		next();
	});
}

for (let i = 0; i < prevButtons.length; i++) {
	prevButtons[i].addEventListener("click", function (event) {
		event.preventDefault();
		prev();
	});
}

const quoteformValidation = $('#wpcf7-f266-o1 .wpcf7-form').validate({
	submitHandler: function () { }, // prevent traditional form submission
	errorClass: "invalid-input",
	rules: {
		'modal_property_type': {
			required: true,
		},
		'modal_pest_type': {
			required: true,
		},
		'modal_house_type': {
			required: true,
		},
		'modal_location': {
			required: true,
		},
		'modal_house_type': {
			required: true,
		},
		'modal_bedroom_size': {
			required: true,
		},
		'modal_full_name': {
			required: true,
		},
		'modal_email': {
			required: true,
			email: true,
		},
		'modal_telephone': {
			required: true,
		},
		'modal_checkbox': {
			required: true,
		},
	},
	messages: {
		modal_property_type: {
			required: "Please select your property type."
		},
		modal_pest_type: {
			required: "Please select your pest concern."
		},
		modal_house_type: {
			required: "Please select your house type."
		},
		modal_file: {
			required: "Please choose a file to upload."
		},
		modal_location: {
			required: "Please enter a location."
		},
		modal_full_name: 'Please enter your name.',
		modal_email: 'Please enter a valid email.',
		modal_telephone: 'Please enter your telephone number.',
		modal_checkbox: 'Please agree to the terms and conditions.',
	},
	errorElement: 'p',
	errorLabelContainer: '.error-message',
});

const contactFormValidation = $('#wpcf7-f3046-o2 .wpcf7-for').validate({
	submitHandler: function () { }, // prevent traditional form submission
	errorClass: "invalid-input",
	rules: {
		'contact_name': {
			required: true,
		},
		'contact_email': {
			required: true,
			email: true
		},
		'contact_enquiry': {
			required: true,
		},
		'contact_checkbox': {
			required: true,
		},
	},
	messages: {
		contact_name: {
			required: "Please enter your name."
		},
		contact_email: {
			required: "Please enter your email."
		},
		contact_enquiry: {
			required: "Please your enquiry."
		},
		contact_checkbox: {
			required: "Please agree to the terms and conditions."
		},
	},
	// validClass: "success",
	errorElement: 'p',
	errorLabelContainer: '.error-message',
	success: function(label) {
		// $(".success-message").html("Thank you for your details");
	},
});

var quoteSubmitBtn = document.querySelector("#wpcf7-f266-o1 .wpcf7-submit");
quoteSubmitBtn.addEventListener("click", function () {
	if (current == 3) {
		var validationPassed = modal_full_name.valid();
		console.log(validationPassed);
		if (validationPassed == false) {
			return false;
		}
		var validationPassed = modal_email.valid();
		console.log(validationPassed);
		if (validationPassed == false) {
			return false;
		}
		var validationPassed = modal_telephone.valid();
		console.log(validationPassed);
		if (validationPassed == false) {
			return false;
		}
		var validationPassed = modal_checkbox.valid();
		console.log(validationPassed);
		if (validationPassed == false) {
			return false;
		}
		setTimeout(function () {
			$(".form__l .success-submit").addClass('sent');
		}, 1000);
	}
	// let validation = true;

	// if (validation == true) {

		// $.ajax({
		// 	url: quoteUrl,
		// 	data: data,
		// 	cache: false,
		// 	contentType: false,
		// 	processData: false,
		// 	method: 'POST',
		// 	type: 'POST', // For jQuery < 1.9
		// 	success: function (data) {
		// 		alert(data);
		// 	}
		// });

	// 	$.post(quoteUrl, {
	// 		modal_property_type: modal_property_type.val(),
	// 		modal_pest_type: modal_pest_type.val(),
	// 		modal_house_type: modal_house_type.val(),
	// 		modal_bedroom_size: modal_bedroom_size.val(),
	// 		modal_location: modal_location.val(),
	// 		modal_file: modal_file.val(),
	// 		modal_textarea: modal_textarea.val(),
	// 		modal_business_name: modal_business_name.val(),
	// 		modal_full_name: modal_full_name.val(),
	// 		modal_email: modal_email.val(),
	// 		modal_telephone: modal_telephone.val(),
	// 		modal_checkbox: modal_checkbox.val(),

	// 		isvalid: isvalid
	// 	}, function (data) {
	// 		if (data == 'success') {
	// 			$('input[name="modal_property_type"]').prop('checked', false);
	// 			$('select[name="modal_pest_type"]').val('');
	// 			$('select[name="modal_house_type"]').prop('checked', false);
	// 			$('select[name="modal_bedroom_size"]').val('');
	// 			$('select[name="modal_location"]').val('');
	// 			$('select[name="modal_file"]').val('');
	// 			$('select[name="modal_textarea"]').val('');
	// 			$('select[name="modal_business_name"]').val('');
	// 			$('select[name="modal_full_name"]').val('');
	// 			$('select[name="modal_email"]').val('');
	// 			$('select[name="modal_telephone"]').val('');
	// 			$('select[name="modal_checkbox"]').val('');

	// 			// $(".form-outer").html("<div class='success'><h2>Thank you for your details</h2><h3>We will take a look at your information and get<br> back to you as soon as possible with a quote</h3><div class='buttons'><a href='/quote-builder/' class='button' id='restartForm'>Restart Form</a><a href='/' class='button'>Return Home</a></div></div>");

	// 			console.log('success');
	// 		} else {
	// 			console.log('fail');
	// 			return false;
	// 		}
	// 	});

	// } else {
	// 	console.log('validation failed');
	// 	return false;
	// }

});

var contactSubmitBtn = document.querySelector(".form__r .wpcf7 .wpcf7-submit");
contactSubmitBtn.addEventListener("click", function () {
	// Validate required fields else terminate click event
	var validationPassed = contact_name.valid();
	console.log(validationPassed);
	if (validationPassed == false) {
		return false;
	}
	var validationPassed = contact_email.valid();
	console.log(validationPassed);
	if (validationPassed == false) {
		return false;
	}
	var validationPassed = contact_enquiry.valid();
	console.log(validationPassed);
	if (validationPassed == false) {
		return false;
	}
	var validationPassed = contact_checkbox.valid();
	console.log(validationPassed);
	if (validationPassed == false) {
		return false;
	}
	setTimeout(function () {
		$(".form__r .success-submit").addClass('sent');
	}, 1000);
	// let validation = true;
	// if (validation == true) {
	// 	$.post(contactUrl, {
	// 		contact_name: contact_name.val(),
	// 		contact_email: contact_email.val(),
	// 		contact_enquiry: contact_enquiry.val(),
	// 		contact_checkbox: contact_checkbox.val(),

	// 		isvalid: isvalid
	// 	}, function (data) {
	// 		console.log(data);
	// 		if (data == 'success') {
	// 			console.log('contact');
	// 			$('[name="contact_name"]').val('');
	// 			$('[name="contact_email"]').val('');
	// 			$('[name="contact_enquiry"]').val('');
	// 			$('[name="contact_checkbox"]').val('');

	// 			$(".success-message p").html("Message Sent! We will get back to you as soon as possible").fadeIn(3000).delay(1000).fadeOut("slow");
	// 			$('#contact').trigger('reset');
	// 			return false;
	// 		} else {
	// 			console.log('fail');
	// 			return false;
	// 		}
	// 	});

	// } else {
	// 	console.log('validation failed');
	// 	return false;
	// }

});

function prev() {
	$('.page-'+current).removeClass('current');
	$('.page-' + (current - 1)).addClass('current');
	slidePage.style.marginLeft = `-${(100 / stepsNumber) * (current - 2)}%`;
	current -= 1;
}
function next() {
	// console.log('.page-' + (current + 1));
	$('.page-' + current).removeClass('current');
	$('.page-' + (current + 1)).addClass('current');
	slidePage.style.marginLeft = `-${(100 / stepsNumber) * current}%`;
	current += 1;
}

const sidebarOpen = document.querySelector('.sidebar-info');
const sticky_element = document.querySelector('.sticky-element');
sidebarOpen.addEventListener('click', (e) => {
	e.preventDefault();
	sticky_element.classList.toggle("active");
	html[0].classList.toggle("lock-scroll");
});
